import axios from "axios";
import { API_URL } from "../services";

// 26.10.2026 — güvenlik manifesti A4 + FE-P2-3: oturumun yerel kaydı tek yerden.
//  - Giriş token'ı artık 30 gün geçerli; yanıttaki expiredTimestamp (Unix sn) saklanır, süresi dolmadan
//    kullanıcı giriş ekranına alınır (App.js periyodik kontrol).
//  - Çıkışta token sunucuda da iptal edilir (flow/user-logout). Uç BE'de henüz yoksa yanıt yok sayılır;
//    yerel temizlik her durumda yapılır. İstek token silindikten SONRA gider: "Invalid token" dönerse
//    apiOturum yakalayıcısı ikinci bir "oturum-dustu" olayı üretmez (saklı token artık yok).
const VADE_ANAHTARI = "tokenExpiresAt";
const YEREL_ANAHTARLAR = ["token", "username", "name", "lastname", "userID", VADE_ANAHTARI];

function saklanan(anahtar) {
  try {
    return sessionStorage.getItem(anahtar) || localStorage.getItem(anahtar) || "";
  } catch (e) {
    return "";
  }
}

/** user-login yanıtındaki vadeyi saklar (expiredTimestamp ya da expired; ms gelirse saniyeye çevrilir). */
export function tokenVadesiniKaydet(sonuc) {
  try {
    let v = Number(sonuc?.expiredTimestamp ?? sonuc?.expired);
    if (!Number.isFinite(v) || v <= 0) {
      localStorage.removeItem(VADE_ANAHTARI);
      return;
    }
    if (v > 1e12) v = Math.floor(v / 1000);
    localStorage.setItem(VADE_ANAHTARI, String(Math.floor(v)));
  } catch (e) {
    /* depolama kapalı: vade kontrolü yapılmaz, BE "Invalid token" ile yine düşürür */
  }
}

/** Saklı vade dolmuş ya da dolmak üzereyse (pay sn) true. Vade bilinmiyorsa false. */
export function tokenVadesiDolduMu(paySn = 60, simdi = Date.now()) {
  const v = Number(saklanan(VADE_ANAHTARI));
  if (!Number.isFinite(v) || v <= 0) return false;
  return simdi / 1000 >= v - paySn;
}

/** Yerel oturumu temizler ve token'ı sunucuda iptal ettirir (sonucu beklenmez). */
export function oturumuKapat() {
  const token = saklanan("token");
  for (const a of YEREL_ANAHTARLAR) {
    try {
      sessionStorage.removeItem(a);
      localStorage.removeItem(a);
    } catch (e) {
      /* yoksay */
    }
  }
  if (token) {
    axios({
      method: "post",
      url: `${API_URL}flow/user-logout`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    }).catch(() => {});
  }
}
